import i18n from "i18next";
import type { ReactNode } from "react";

import { ConfirmationModal } from "./ConfirmationModal";

interface InheritedFieldChangeConfirmationModalProps {
    open: boolean;
    onConfirm: () => void;
    onCancel: () => void;
    title?: string;
    message?: ReactNode;
}

export const InheritedFieldChangeConfirmationModal = ({
    open,
    onConfirm,
    onCancel,
    title,
    message,
}: InheritedFieldChangeConfirmationModalProps) => {
    return (
        <ConfirmationModal
            visible={open}
            onOk={onConfirm}
            onCancel={onCancel}
            title={title ?? i18n.t("modal.title.overwriteValues")}
            message={message ?? i18n.t("modal.label.inheritedValuesWillChange")}
        />
    );
};
